<div #switch class="switch">
    <div class="toggle"></div>
    <span class="on">ON</span>
    <span class="off">OFF</span>
</div>
